const STORAGE_KEY = 'card-war-ended-instances';
const MAX_ENTRIES = 50;

/**
 * Card War instances the player has ended by tapping x on Do-It-Again.
 *
 * The quit itself is recorded server-side, but in metagames-api — the lobby widget is built by
 * monetization, which cannot see it, so the widget would come back on the next fetch. This is the
 * client remembering instead.
 *
 * Per device, so the widget can reappear on another one. The cost is bounded: opening it lands on
 * the game's own "You have finished this Card War event" screen rather than anything broken.
 *
 * Keyed by user AND coin: a browser can be shared, and SC and GC are independent instances — ending
 * one must leave the other alone.
 */
const instanceKey = (userId: string, eventId: string, coinType: string) => `${userId}:${eventId}:${coinType}`;

const readEnded = (): string[] => {
  try {
    const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') as unknown;
    return Array.isArray(data) ? data.filter((value): value is string => typeof value === 'string') : [];
  } catch {
    return [];
  }
};

export const hasEndedCardWarInstance = (userId: string, eventId: string, coinType: string): boolean =>
  readEnded().includes(instanceKey(userId, eventId, coinType));

export const markCardWarInstanceEnded = (userId: string, eventId: string, coinType: string): void => {
  const key = instanceKey(userId, eventId, coinType);
  const ended = readEnded();

  if (ended.includes(key)) {
    return;
  }

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([key, ...ended].slice(0, MAX_ENTRIES)));
  } catch {
    // ignore storage failures (private mode / quota)
  }
};
